<template>
  <el-card shadow="never" class="reporting-content">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="block-title">
          VAT/Percentage
        </div>
        <ul>
          <li><span class="text">Vatable Registered:</span><span class="value">{{ vatableRegisteredName }}</span></li>
          <li><span class="text">Tax Formation:</span><span class="value">{{taxFormationName}}</span></li>
          <li><span class="text">Tax Identification No. (TIN):</span><span class="value">{{ form.taxIdentification }}</span></li>
          <li><span class="text">Regional District Office (RDO):</span><span class="value">{{regionalDistrictOfficeName}}</span></li>
          <li><span class="text">Method of Deduction:</span><span class="value">{{ methodOfDeductionName }}</span></li>
          <li><span class="text">Are you availing of tax relief under Special <br/> Laws or International Tax Treaty:</span><span class="value">{{ form.availingOfTaxRelief === 'yes' ? 'Yes' : 'No'}}</span></li>
        </ul>
        <el-button size="mini" :disabled="!form.certificate" @click="viewFile(form.certificate.url)">
          Open Certificate of Registration (COR)
        </el-button>
      </el-col>
      <el-col :span="12">
        <div class="block-title">
          Withholding Tax Agent
        </div>
        <ul>
          <li><span class="text">Category of Withholding Agent:</span><span class="value">{{ categoryOfWithholdingAgentName }}</span></li>
          <li><span class="text">Registered Name:</span><span class="value">{{form.registeredName}}</span></li>
          <li><span class="text">Taxpayer Name:</span><span class="value">{{form.taxPayerName}}</span></li>
          <li><span class="text">Registered/Business Address:</span><span class="value">{{form.businessAddress}}</span></li>
          <li><span class="block-title" style="margin-top: 10px">Authorised Representative/Signatory</span></li>
          <li><span class="text">Name:</span><span class="value">{{form.signatoryName}}</span></li>
          <li><span class="text">Position/Title:</span><span class="value">{{form.signatoryPosition}}</span></li>
        </ul>
      </el-col>
    </el-row>
    <div v-if="viewerType == 1">
      <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
        <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
      </sweet-modal>
    </div>
    <div v-if="viewerType == 2">
      <div v-show="false" class="images" v-viewer="{movable: true}">
        <img :src="fileUrl" :key="fileUrl" />
      </div>
    </div>
    <div class="mod" v-if="viewerType == 3">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
          :kind="'video'"
          :controls="true"
          :src="fileUrl"
      >
      </Media>
    </div>
    <div class="mod" v-if="viewerType == 4">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
          :kind="'audio'"
          :controls="true"
          :src="fileUrl"
      >
      </Media>
    </div>
  </el-card>
</template>

<script>
import axios from "axios";
import {viewEditFileMixin} from "@/mixins/viewEditFileMixin";
import Media from '@dongido/vue-viaudio'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

export default {
  name: "TaxationContent",
  mixins: [viewEditFileMixin],
  components: {
    Media,
    SweetModal
  },
  data() {
    return {
      form: {
        countryForTaxRepId: null,
        taxReporting: null,
        vatableRegistered: null,
        taxFormation: null,
        taxFormationListId: null,
        taxIdentification: null,
        regionalDistrictOffice: null,
        methodOfDeduction: null,
        availingOfTaxRelief: 'no',
        categoryOfWithholdingAgent: null,
        registeredName: null,
        businessAddress: null,
        signatoryName: null,
        signatoryPosition: null,
        certificate: null,
        specify: null,
        taxPayerName: null
      },
      taxFormationListList: [],
      taxFormationList: [],
      regionalDistrictOfficeList: [],
      methodOfDeductionList: [],
      countryId: 0,
      // vatableRegisteredList: [
        // { id: 'Vatable', name: 'Vatable' },
        // { id: 'Percentage Tax', name: 'Percentage Tax' },
        // { id: 'Tax Exempt', name: 'Tax Exempt' },
        // { id: 'Zero Rated', name: 'Zero Rated' },
      // ],
      categoryOfWithholdingAgentList: [
        { id: 'Private (P)', name: 'Private (P)' },
        { id: 'Government (G)', name: 'Government (G)' },
      ],
    }
  },
  computed: {
    vatableRegisteredName() {
      return this.form.vatableRegistered && this.form.vatableRegistered.name ? this.form.vatableRegistered.name : null
    },
    taxFormationName() {
      const taxFormation = this.taxFormationList.find(val => val.id === this.form.taxFormation)
      return taxFormation ? taxFormation.name : null
    },
    regionalDistrictOfficeName() {
      const regionalDistrict = this.regionalDistrictOfficeList.find(val => val.id === this.form.regionalDistrictOffice)
      return regionalDistrict ? regionalDistrict.name : null
    },
    methodOfDeductionName() {
      const methodOfDeduction = this.methodOfDeductionList.find(val => val.id === this.form.methodOfDeduction)
      return methodOfDeduction ? methodOfDeduction.name : null
    },
    categoryOfWithholdingAgentName() {
      const categoryOfWithholdingAgent = this.categoryOfWithholdingAgentList.find(val => val.id === this.form.categoryOfWithholdingAgent)
      return categoryOfWithholdingAgent ? categoryOfWithholdingAgent.name : null
    }
  },
  async mounted() {
    await this.loadItem()
    await this.loadData()
    await this.loadFile()
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data: taxFormationList } = await axios.get(`/api/v1/tax-formation/list?countryId=${this.form.countryForTaxRepId ? this.form.countryForTaxRepId : this.countryId}`)
      this.taxFormationList = taxFormationList.list
      const { data: regionalDistrictOfficeList } = await axios.get(`/api/v1/rdo/list?countryId=${this.countryId}`)
      this.regionalDistrictOfficeList = regionalDistrictOfficeList.list
      const { data: methodOfDeductionList } = await axios.get(`/api/v1/method-of-deduction/list?countryId=${this.countryId}`)
      this.methodOfDeductionList = methodOfDeductionList.list
      loader.hide()
    },
    async loadItem() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data: item } = await axios.get(`/api/v1/company-taxation-info/item?companyId=${this.$route.query.companyId}`)
      if (item.item) {
        this.form.taxReporting = item.item.taxReporting
        if (item.item.taxClassificationId) {
          this.form.countryForTaxRepId = item.item.countryForTaxRepId
          this.form.taxFormation = item.item.taxFormationId
          this.form.taxFormationListId = item.item.taxFormationListId
          this.form.regionalDistrictOffice = item.item.rdoId
          this.form.methodOfDeduction = item.item.methodOfDeductionId
          this.form.vatableRegistered = item.item.vatableRegistered
          this.form.taxIdentification = item.item.taxIdentification
          this.form.availingOfTaxRelief = item.item.availingOfTaxRelief
          this.form.categoryOfWithholdingAgent = item.item.categoryOfWithholdingAgent
          this.form.registeredName = item.item.registeredName
          this.form.businessAddress = item.item.businessAddress
          this.form.signatoryName = item.item.signatoryName
          this.form.signatoryPosition = item.item.signatoryPosition
          this.form.specify = item.item.specify
          this.form.taxPayerName = item.item.taxPayerName
          await this.loadTaxFormationList(this.form.taxFormation)
        }
      }
    },
    async loadFile() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.post(`/api/v1/entityFiles/listOfArrTypeId?entityId=${this.$route.query.companyId}`, { entityTypeIdArr: [71] })
      this.form.certificate = data.list.length ? data.list[0] : null
    },
    async loadTaxFormationList(taxFormationId) {
      const loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.get(`/api/v1/tax-formation-list/list?countryId=${this.form.countryForTaxRepId}&taxFormationId=${taxFormationId}`)
      this.taxFormationListList = data.list
      loader.hide()
    },
    closeMod() {
      this.viewerType = 0;
    },
  }
}
</script>

<style lang="scss" scoped>
.reporting-content {
  ul {
    margin-top: 20px;
    list-style: none;
    padding-left: 0;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
      .text {
        font-size: 18px;
        color: grey;
      }
      .value {
        margin-left: 10px;
      }
    }
  }
  .block-title {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
